import script from "./SpotWorkerSlot.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpotWorkerSlot.vue?vue&type=script&setup=true&lang=ts"

import "./SpotWorkerSlot.vue?vue&type=style&index=0&id=09a6d7a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09a6d7a0"]])

export default __exports__